export default "__VITE_ASSET__kj9KDWot__"